export default __webpack_public_path__ + "static/media/botGoogle.ea348168.PNG";